import _ from "lodash";

import { CollectionAdapter } from "../../main/adapters/CollectionAdapter/CollectionAdapter";
import { HttpAdapter } from "../../main/adapters/HttpAdapter";

const DashboardAvailableCollection = new Mongo.Collection(
    "DashboardAvailable",
    {
        connection: null
    }
);

export class DashboardAvailable extends CollectionAdapter {
    HttpAdapter = new HttpAdapter();
    baseUrlDashboard = `${publicSettings.aws.baseUrls.dataTimeseries}/dashboard`;

    constructor({ CompanyDataAvailable, Available } = {}) {
        super(DashboardAvailableCollection);

        this.CompanyDataAvailable = CompanyDataAvailable;
        this.Available = Available;
    }

    async populate({ companyId }) {
        const dashboardIds = await this.groupIdsBySource({ companyId });

        this.deleteMany({ companyId });

        this.create({
            companyId,
            dashboardIds
        });

        return dashboardIds || [];
    }

    async groupIdsBySource({ companyId }) {
        const response = await this.HttpAdapter.call(
            `${this.baseUrlDashboard}/get-group-by-ids-source`,
            { companyId }
        );
        return response.result;
    }

    getFirstId({ companyId, source }) {
        const dashboard = this.findOneCollection({
            companyId
        });

        const dashboardIdsBySource = dashboard.dashboardIds.find(
            (dash) => dash.source == source
        );

        if (!dashboardIdsBySource) return null;

        return _.head(dashboardIdsBySource._ids);
    }

    getDashboardsIds({ companyId, source }) {
        const dashboard = this.findOneCollection({
            companyId
        });

        const dashboardIdsBySource = dashboard.dashboardIds.find(
            (dash) => dash.source == source
        );

        if (!dashboardIdsBySource) return null;

        return dashboardIdsBySource._ids;
    }

    getTaxDashboardId({ source, available, companyId }) {
        if (source === "simplesNacional") {
            const taxDashboardsIds = this.getDashboardsIds({
                companyId,
                source
            });

            if (!taxDashboardsIds) return "";

            if (_.get(available, `date.ORIGINAL.${source}.length`) === 1) {
                return taxDashboardsIds[2];
            } else {
                return taxDashboardsIds[0];
            }
        } else {
            return this.getFirstId({
                companyId,
                source
            });
        }
    }

    validateDashboard({ companyId, dashboardId, source }) {
        const dashboard = this.findOneCollection({
            companyId
        });

        const dashboardIdsBySource = dashboard.dashboardIds.find(
            (dash) => dash.source == source
        );

        if (dashboardIdsBySource) {
            const hasId = dashboardIdsBySource._ids.find((_id) => {
                return _id == dashboardId;
            });

            if (hasId) return dashboardId;
            else {
                const dashboardIdsBySource = dashboard.dashboardIds.find(
                    (dash) => dash.source == source
                );

                if (!dashboardIdsBySource) return null;

                return _.head(dashboardIdsBySource._ids);
            }
        }
    }

    getByDashboardId({ companyId, dashboardId }) {
        if (!companyId || !dashboardId) return {};

        const dashboardsAvailable = this.findOneCollection({
            companyId
        });

        if (!dashboardsAvailable) return {};

        const dashboard = dashboardsAvailable.dashboardIds.find((d) => {
            return d._ids.includes(dashboardId);
        });

        if (!dashboard) return {};

        return dashboard;
    }

    addId({ companyId, source, id }) {
        const collection = this.findCollection({ companyId }, {}, "array");
        if (collection?.[0]) {
            const dashsAvailable = collection?.[0];
            const dashSource = dashsAvailable.dashboardIds.find(
                (d) => d.source === source
            );
            dashSource._ids.push(id);
            this.deleteMany({ companyId });
            this.create({
                companyId,
                dashboardIds: dashsAvailable.dashboardIds
            });
        }
    }
}
